/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  accessRoleData,
  idAccessRole,
}) {
  try {
    return questionnaire.map(question => {
      if (accessRoleData) {
        if (question.idQuestion === 1952) {
          question.answer = accessRoleData.roleName;
          setFieldValue(question.key, accessRoleData.roleName)
        }

        if (question.idQuestion === 1953) {
          const roleTypeOption = accessRoleData.behavior?.isExternalAccessRole ? 7610 : 7609

          const selectedOption = question.answerOptions.find(option => option.idAnswerOption === roleTypeOption);

          const result = {
            idAnswerOption: selectedOption?.idAnswerOption,
            dsAnswerOption: selectedOption?.dsAnswerOption,
            resultValue: selectedOption?.behaviorObject?.resultValue || null
          };

          question.answer = selectedOption?.dsAnswerOption;
          question.answerJson = selectedOption.answerJson;
          question.idAnswerOption = selectedOption?.idAnswerOption;
          setFieldValue && setFieldValue(question.key, result);
        }
      }

      if (question.idQuestion === 1975 && idAccessRole) {
        question.answer = idAccessRole;
        setFieldValue(question.key, idAccessRole)
      }
      return question;
    });
  } catch (e) {
    console.log("ACCESS_PROFILE - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("ACCESS_PROFILE - handleQuestionChange error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {

    questionnaire = questionnaire.map(question => {
      return question;
    })

    setQuestionnaire(questionnaire);

  } catch (e) {
    console.log('ACCESS_PROFILE - handleRequestSerproCnpj error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
}

export { events };